import {HttpCrudDataSource} from '../../../core/data-source/http-crud.data-source';
import {fromJson, toJson} from '../../../core/data-source/json.mapper';
import {httpService} from '../../../core/services/http.service';
import {VehicleCheckRecord} from './vehicle-check.record';

export class VehicleChecksCrudDataSource<T> extends HttpCrudDataSource<T> {
    protected apiPath: string = '/gt/gt-api/vehicle_checks/form';

    async removeByReference(reference: string): Promise<boolean> {
        return httpService.delete(`/gt/gt-api/vehicle_checks/form/${reference}`).then((response) => response);
    }
    async getByReference(reference: string): Promise<VehicleCheckRecord> {
        return httpService
            .get(`/gt/gt-api/vehicle_checks/form/${reference}`)
            .then((response: any): VehicleCheckRecord => fromJson(VehicleCheckRecord, response.data));
    }

    async updateByReference(reference: string, record: VehicleCheckRecord): Promise<VehicleCheckRecord> {
        return httpService
            .put(`/gt/gt-api/vehicle_checks/form/${reference}`, JSON.stringify(toJson(record)), {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then((response: any) => response);
    }

    async add(record: VehicleCheckRecord): Promise<VehicleCheckRecord> {
        return httpService
            .post(`/gt/gt-api/vehicle_checks/form`, JSON.stringify(toJson(record)), {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then((response: any): VehicleCheckRecord => fromJson(VehicleCheckRecord, response.data));
    }
}
